import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './FolderCommentThread';
import { AppState } from '../../../../../../types/store';
import { getCurrentUser } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { getFeaturedFolder } from '../../../../../selectors/folders';

export type StateProps = Pick<Props, 'currentUser' | 'featuredFolder'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Without<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  currentUser: getCurrentUser(state),
  featuredFolder: getFeaturedFolder(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
